import { errorD1 } from 'shared/theme/colors'
import { paragraph3 } from 'shared/theme/typography'
import styled, { css } from 'styled-components'

export const AddressContainer = styled.div<{ $noMargin?: boolean }>`
  position: relative;
  width: 100%;
  margin-bottom: 24px;

  ${(p) =>
    p.$noMargin &&
    css`
      margin-bottom: 0;
    `}
`

export const CityState = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 122px;
  width: 100%;
  margin-top: -16px;
  grid-column-gap: 8px;

  @media (max-width: 460px) {
    grid-template-columns: 1fr 1fr;

    > div:first-child {
      grid-column-start: 1;
      grid-column-end: 3;
      margin-bottom: 8px;
    }
  }
`

export const ErrorMessage = styled.div`
  ${paragraph3};
  color: ${errorD1};
  position: absolute;
  bottom: 0;
`
